import { SuperAdminService } from "services/superAdminService";

class DevicesSAService extends SuperAdminService<any> {
  constructor() {
    super("devices");
  }
}
export default new DevicesSAService();
